<template>
  <div>
    <div class="ly-card">
      <el-radio-group v-model="tabValue" @change="search">
        <el-radio-button label="quarter">按季度</el-radio-button>
        <el-radio-button label="room">按教室</el-radio-button>
      </el-radio-group>
      <div class="m-t-10"></div>
      <template v-if="tabValue === 'quarter'">
        <el-select v-model="searchFormData.year" placeholder="学年" class="m-r-10">
          <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-select v-model="searchFormData.term" placeholder="学期" class="m-r-10">
          <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </template>
      <template v-else>
        <el-date-picker
          class="m-r-10"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchFormData.query_date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </template>
      <remote-search class="inline-block m-r-10" :options="class_room_id" @input="(value, label) => searchFormData.query = label" ref="classRoom" />
      <el-button @click="search" type="primary" class="m-r-5">查询</el-button>
      <!-- <el-button type="primary" @click="exportExcel">导出</el-button> -->
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      :tableConfig="tableConfig"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:class_usage_rate="row">
        {{ ((row.class_usage_rate || 0) * 100).toFixed(2) }} %
      </template>
      <template v-slot:valid_use_rate="row">
        {{ ((row.valid_use_rate || 0) * 100).toFixed(2) }} %
      </template>
      <template v-slot:class_time="row">
        {{ (row.class_start_time || '').split(' ')[1] }} - {{ (row.class_end_time || '').split(' ')[1] }}
      </template>
      <template v-slot:action="row">
        <el-button type="text" size="mini" @click="getDetail(row)">查看</el-button>
      </template>
    </ly-table>
    <el-dialog :title="`${searchFormDataDetail.class_room_name}-使用明细`" :visible.sync="dialogVisible" width="800px">
      <ly-table
        :searchFormData="searchFormDataDetail"
        :getTableData="getTableDataDetail"
        :tableHeader="tableHeaderDetail"
        ref="lyTableDetail"
      >
        <template v-slot:class_time="row">
          {{ row.class_start_time.split(' ')[1] }} - {{ row.class_end_time.split(' ')[1] }}
        </template>
      </ly-table>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, RadioGroup, RadioButton, Select, Option, DatePicker } from 'element-ui';
import LyTable from '@/components/LyTable';
import { report } from '@/api';
import { reportRoomTable, reportRoomNextTable, reportRooDetailTable } from '@/utils/tableHeader';
import { class_room_id } from '@/utils/formConfigCommon';
import RemoteSearch from '@/components/common/RemoteSearch';

export default {
  name: 'classRoom',
  components: {
    ElRadioGroup: RadioGroup,
    ElRadioButton: RadioButton,
    LyTable,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker,
    ElDialog: Dialog,
    RemoteSearch
  },
  data() {
    return {
      tabValue: 'quarter',
      searchFormData: {
        year: '',
        query: '',
        term: '',
        query_date: ''
      },
      tableConfig: {},
      terms: [],
      years: [],
      dialogVisible: false,
      searchFormDataDetail: {},
      tableHeaderDetail: reportRooDetailTable,
      getTableDataDetail: report.classroomDetail,
      class_room_id: {
        ...class_room_id.options,
        key: 'class_room_id',
        clearable: true
      }
    };
  },
  mounted() {
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
        this.searchFormData.term = data.term[0].value;
        this.searchFormData.year = `${new Date().getFullYear()}`;
        this.search();
      }
    });
  },
  computed: {
    getTableData() {
      if (this.tabValue === 'room') {
        return report.roomStatisticsRoom;
      }
      return report.roomStatisticsQuarter;
    },
    tableHeader() {
      if (this.tabValue === 'room') {
        return reportRoomNextTable;
      }
      return reportRoomTable;
    }
  },
  methods: {
    search() {
      if (this.searchFormData.query_date) {
        [this.searchFormData.query_start_date, this.searchFormData.query_end_date] = this.searchFormData.query_date;
      }
      this.$refs.lyTable.setData();
    },
    exportExcel() {},
    getDetail(row) {
      this.dialogVisible = true;
      this.searchFormDataDetail = row;
      setTimeout(() => {
        this.$refs.lyTableDetail.setData();
      }, 0);
    }
  }
};
</script>
